import {
    HttpTaskServiceList,
    HttpAccountAllList,
    HttpProductLineAllList,
    // HttpWarehouseAllList,
    // HttpUserList,
    HttpProductList,
    HttpAccountList,
    HttpWarehouseList,
    // HttpVsGroups,
    // HttpPlatform,
    HttpGetContry,
    SystemDelivery,
    NewSystemDelivery,
    NewSystemCarrier,
    SystemWarehouse,
    OrgWarehouse,
    SystemShippingCode,
    SystemCarrier,
    SystemService,
    HttpAccountType,
    HttpAllaccountType
} from "@/service/boss/dictionary";

export default {
    namespaced: true,
    state: {
        taskServiceAll: [],
        accountAll: [],
        productLineAll: [],
        products: [],
        accounts: [],
        warehouseList: [],
        countries: [],
        sysdeliveries: [],
        newSysdeliveries: [],
        syswarehouses: [],
        orgwarehouses: [],
        sysshippingcode: [],
        syscarrier: [],
        newSysCarrier: [],
        sysservice: [],
        accountTypes: [],
        allaccounties: [],
    },
    getters: {
        accountFlag (state) {
            return state.accounts.filter(json => {
                return json.type === "amazon";
            });
        },
        accountTypeList (state) {
            const types = state.accounts.map(json => {
                return json.type
            });
            return [...new Set(types)]
        },
        // 非 amazon Warehouses和
        warehouses (state) {
            return state.warehouseList.filter(item => {
                return item.warehouseType !== 2 && item.warehouseType !== 4;
            });
        },
        //非amazon Warehouses
        otherWarehouses (state) {
            return state.warehouseList.filter(item => {
                return item.warehouseType !== 2
            });
        },
        //amazon Warehouses
        amazonWarehouses (state) {
            return state.warehouseList.filter(item => {
                return item.warehouseType == 2;
            });
        }
    },
    mutations: {
        taskServiceAll (state, payload) {
            sessionStorage.BOSS_TASKSERVICEALL = JSON.stringify(payload);
            state.taskServiceAll = payload;
        },
        accountAll (state, payload) {
            sessionStorage.BOSS_ACCOUNTALL = JSON.stringify(payload);
            state.accountAll = payload;
        },
        productLineAll (state, payload) {
            sessionStorage.BOSS_PRODUCTLINEALL = JSON.stringify(payload);
            state.productLineAll = payload;
        },
        products (state, payload) {
            payload = (payload || []).sort(function (pre, cur) {
                return pre.name > cur.name ? 1 : -1;
            });
            sessionStorage.BOSS_PRODUCTLIST = JSON.stringify(payload);
            state.products = payload;
        },
        accounts (state, payload) {
            sessionStorage.BOSS_ACCOUNTLIST = JSON.stringify(payload);
            state.accounts = payload;
        },
        warehouseList (state, payload) {
            sessionStorage.BOSS_WAREHOUSELIST = JSON.stringify(payload);
            state.warehouseList = payload;
        },
        countries (state, payload) {
            sessionStorage.BOSS_COUNTRYLIST = JSON.stringify(payload);
            state.countries = payload;
        },
        sysdeliveries (state, payload) {
            sessionStorage.BOSS_SYSDELIVERYLIST = JSON.stringify(payload);
            state.sysdeliveries = payload;
        },
        newSysdeliveries (state, payload) {
            sessionStorage.BOSS_NEWSYSDELIVERYLIST = JSON.stringify(payload);
            state.newSysdeliveries = payload;
        },
        newSysCarrier (state, payload) {
            sessionStorage.BOSS_NEWSYSCARRIERLIST = JSON.stringify(payload);
            state.newSysCarrier = payload;
        },
        syswarehouses (state, payload) {
            sessionStorage.BOSS_SYSWAREHOUSE = JSON.stringify(payload);
            state.syswarehouses = payload;
        },
        orgwarehouses (state, payload) {
            sessionStorage.BOSS_ORGWAREHOUSE = JSON.stringify(payload);
            state.orgwarehouses = payload;
        },
        // shoppingcode、carrier、service
        sysshippingcode (state, payload) {
            sessionStorage.BOSS_SYSSHIPPINGCODE = JSON.stringify(payload);
            state.sysshippingcode = payload;
        },
        syscarrier (state, payload) {
            sessionStorage.BOSS_SYSCARRIER = JSON.stringify(payload);
            state.syscarrier = payload;
        },
        sysservice (state, payload) {
            sessionStorage.BOSS_SYSSERVICE = JSON.stringify(payload);
            state.sysservice = payload;
        },
        accountTypes (state, payload) {
            sessionStorage.BOSS_ACCOUNTTYPES = JSON.stringify(payload);
            state.accountTypes = payload;
        },
        allaccounties (state, payload) {
            sessionStorage.BOSS_ALLACCOUNTIES = JSON.stringify(payload);
            state.allaccounties = payload;
        },
    },
    actions: {
        async actionInit ({ commit, dispatch }, payload) {
            if (payload) {
                sessionStorage.BOSS_TASKSERVICEALL =
                    sessionStorage.BOSS_ACCOUNTALL =
                    sessionStorage.BOSS_PRODUCTLINEALL =
                    sessionStorage.BOSS_PRODUCTLIST =
                    sessionStorage.BOSS_ACCOUNTLIST =
                    sessionStorage.BOSS_WAREHOUSELIST =
                    sessionStorage.BOSS_COUNTRYLIST =
                    sessionStorage.BOSS_SYSDELIVERYLIST =
                    sessionStorage.BOSS_NEWSYSDELIVERYLIST =
                    sessionStorage.BOSS_SYSWAREHOUSE =
                    sessionStorage.BOSS_ORGWAREHOUSE =
                    sessionStorage.BOSS_SYSSHIPPINGCODE =
                    sessionStorage.BOSS_SYSCARRIER =
                    sessionStorage.BOSS_NEWSYSCARRIERLIST =
                    sessionStorage.BOSS_SYSSERVICE =
                    sessionStorage.BOSS_ACCOUNTTYPES =
                    sessionStorage.BOSS_ALLACCOUNTIES = "";
            }
            dispatch("actionGetTaskService");
            dispatch("actionGetAccountAll");
            dispatch("actionGetProductLineAll");
            dispatch("actionGetProducts");
            dispatch("actionGetAccounts");
            dispatch("actionGetWarehouses");
            dispatch("actionGetCountries");
            dispatch("actionGetSysDeliveries");
            dispatch("actionGetNewSysDeliveries");
            dispatch("actionGetNewSysCarrier");
            dispatch("actionGetSysWarehouses");
            dispatch("actionGetOrgWarehouses");
            dispatch("actionGetSysShippingCode");
            dispatch("actionGetSysCarrier");
            dispatch("actionGetSysService");
            dispatch("actionGetAccountTypes");
            dispatch("actionGetAllaccounties");
        },

        async actionGetTaskService ({ commit }) {
            const taskServiceAll = sessionStorage.BOSS_TASKSERVICEALL;
            if (taskServiceAll) {
                commit("taskServiceAll", JSON.parse(taskServiceAll));
                return;
            }
            return HttpTaskServiceList().then(res => {
                commit("taskServiceAll", res.data || []);
            });
        },

        async actionGetAccountAll ({ commit }) {
            const accountAll = sessionStorage.BOSS_ACCOUNTALL;
            if (accountAll) {
                commit("accountAll", JSON.parse(accountAll));
                return;
            }
            return HttpAccountAllList().then(res => {
                commit("accountAll", res.data || []);
            });
        },

        async actionGetProductLineAll ({ commit }) {
            const productLineAll = sessionStorage.BOSS_PRODUCTLINEALL;
            if (productLineAll) {
                commit("productLineAll", JSON.parse(productLineAll));
                return;
            }
            return HttpProductLineAllList().then(res => {
                commit("productLineAll", res.data || []);
            });
        },

        async actionGetProducts ({ commit }) {
            const products = sessionStorage.BOSS_PRODUCTLIST;
            if (products) {
                commit("products", JSON.parse(products));
                return;
            }
            return HttpProductList().then(res => {
                commit("products", res.data || []);
            });
        },
        async actionGetAccounts ({ commit }) {
            const accounts = sessionStorage.BOSS_ACCOUNTLIST;
            if (accounts) {
                commit("accounts", JSON.parse(accounts));
                return;
            }
            return HttpAccountList().then(res => {
                commit("accounts", res.data || []);
            });
        },

        async actionGetWarehouses ({ commit }) {
            const warehouseList = sessionStorage.BOSS_WAREHOUSELIST;
            if (warehouseList) {
                commit("warehouseList", JSON.parse(warehouseList));
                return;
            }
            return HttpWarehouseList().then(res => {
                commit("warehouseList", res.data || []);
            });
        },
        async actionGetCountries ({ commit }) {
            const countries = sessionStorage.BOSS_COUNTRYLIST;
            if (countries) {
                commit("countries", JSON.parse(countries));
                return;
            }
            return HttpGetContry({
                "search[EQ_depth]": 2
            }).then(res => {
                commit("countries", res.data || []);
            });
        },
        async actionGetSysDeliveries ({ commit }) {
            const sysdeliveries = sessionStorage.BOSS_SYSDELIVERYLIST;
            if (sysdeliveries) {
                commit("sysdeliveries", JSON.parse(sysdeliveries));
                return;
            }
            return SystemDelivery().then(res => {
                commit("sysdeliveries", res.data || []);
            });
        },
        async actionGetNewSysDeliveries ({ commit }) {
            const newSysdeliveries = sessionStorage.BOSS_NEWSYSDELIVERYLIST;
            if (newSysdeliveries) {
                commit("newSysdeliveries", JSON.parse(newSysdeliveries));
                return;
            }
            return NewSystemDelivery({
                search: {
                    EQ_active: 1
                }
            }).then(res => {
                commit("newSysdeliveries", res.data || []);
            });
        },
        async actionGetNewSysCarrier ({ commit }) {
            const newSysCarrier = sessionStorage.BOSS_NEWSYSCARRIERLIST;
            if (newSysCarrier) {
                commit("newSysCarrier", JSON.parse(newSysCarrier));
                return;
            }
            return NewSystemCarrier({
                search: {
                    EQ_active: 1
                }
            }).then(res => {
                commit("newSysCarrier", res.data || []);
            });
        },
        async actionGetSysWarehouses ({ commit }) {
            const syswarehouses = sessionStorage.BOSS_SYSWAREHOUSE;
            if (syswarehouses) {
                commit("syswarehouses", JSON.parse(syswarehouses));
                return;
            }
            return SystemWarehouse().then(res => {
                // console.log(res)
                commit("syswarehouses", res.data || []);
            });
        },
        async actionGetOrgWarehouses ({ commit }) {
            const orgwarehouses = sessionStorage.BOSS_ORGWAREHOUSE;
            if (orgwarehouses) {
                commit("orgwarehouses", JSON.parse(orgwarehouses));
                return;
            }
            return OrgWarehouse().then(res => {
                commit("orgwarehouses", res.data || []);
            });
        },
        // shoppingcode、carrier、service
        async actionGetSysShippingCode ({ commit }) {
            const sysshippingcode = sessionStorage.BOSS_SYSSHIPPINGCODE;
            if (sysshippingcode) {
                commit("sysshippingcode", JSON.parse(sysshippingcode));
                return;
            }
            return SystemShippingCode().then(res => {
                commit("sysshippingcode", res.data || []);
            });
        },
        async actionGetSysCarrier ({ commit }) {
            const syscarrier = sessionStorage.BOSS_SYSCARRIER;
            if (syscarrier) {
                commit("syscarrier", JSON.parse(syscarrier));
                return;
            }
            return SystemCarrier().then(res => {
                commit("syscarrier", res.data || []);
            });
        },
        async actionGetSysService ({ commit }) {
            const sysservice = sessionStorage.BOSS_SYSSERVICE;
            if (sysservice) {
                commit("sysservice", JSON.parse(sysservice));
                return;
            }
            return SystemService().then(res => {
                commit("sysservice", res.data || []);
            });
        },
        async actionGetAccountTypes ({ commit }) {
            const accountTypes = sessionStorage.BOSS_ACCOUNTTYPES;
            if (accountTypes) {
                commit("accountTypes", JSON.parse(accountTypes));
                return;
            }
            return HttpAccountType().then(res => {
                commit("accountTypes", res.data || []);
            });
        },
        async actionGetAllaccounties ({ commit }) {
            const allaccounties = sessionStorage.BOSS_ALLACCOUNTIES;
            if (allaccounties) {
                commit("allaccounties", JSON.parse(allaccounties));
                return;
            }
            return HttpAllaccountType().then(res => {
                commit("allaccounties", res.data || []);
            });
        },

    }
};
